<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" style="font-size: 24px;" class="pointer green" /></router-link>
                    Roles
                    <font-awesome-icon :icon="['fa', 'plus']" style="font-size: 24px;" class="pointer green " @click="ShowAddModal" />
                    <b-col cols="2">
                        <input class="form-control" v-model="search" type="text" placeholder="Search" aria-label="Search" @input="RedrawTable()" />
                    </b-col>
                    <span class="AddModal">

                        <b-modal @show="ClearForm" @hidden="ClearForm" ref="component-modal" title="Add Role" hide-footer>
                            <b-container fluid>
                                <b-form @submit="AddRole">
                                    <b-row>
                                        <b-col cols="12"><b>Role Name:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.name" placeholder="Required" type="name" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Role Description:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="form.description"></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Parent Role:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem">
                                            <select class="form-control" v-model="form.parentRoleId">
                                                <option value="">NONE</option>
                                                <option v-for="role in RoleList" :value="role.Id">
                                                    {{ role.Name }}
                                                </option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <h3>Add permissions to your role</h3>
                                            <b-list-group flush style="padding:0px;">
                                                <b-list-group-item style="padding:0px;">
                                                    <div v-for="permission in PermissionList">
                                                        <b-form-checkbox size="lg" v-model="permission.checked">
                                                            {{permission.Name}}
                                                        </b-form-checkbox>
                                                    </div>
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="Cancel()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="primary" type="submit">
                                                CONFIRM
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>
                <vuetable :fields="RoleTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="RoleActions" scope="props">
                        <div class="RoleActionDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px; margin-right:1rem;" class="pointer orange " @click="EditRoleButton(props.rowData)" />
                                </b-col>
                                <b-col md="auto">
                                    <ActionButtonWithIcon :requires-confirmation="true"
                                              confirmation-string="WARNING: You are about to delete this role.  Are you sure?"
                                              endpoint="Admin/UserManagement/DeleteRole"
                                              :payload="{Id: props.rowData.Id}"
                                              :perform-global-update="false"
                                              button-variant="success"
                                              button-string=""
                                              button-size="md"
                                              emit-on-success="role-deleted"
                                              v-on:success="RefreshDataTable" 
                                              icon-prefix="fa"
                                              icon-suffix="trash-alt"
                                              icon-color="red"
                                              method="POST"/>
                                </b-col>
                                <!--<b-col md="auto">
                                    <font-awesome-icon :icon="['fa', 'plus-square']" style="font-size: 24px; margin-right:1rem;" class="pointer green" @click="AddPermissionsToRoleButton(props.rowData)" />
                                </b-col>
                                <b-col md="auto">
                                    <font-awesome-icon :icon="['fa', 'minus-square']" style="font-size: 24px; margin-right:1rem;" class="pointer red" @click="RemoveRoleFromPermissionsButton(props.rowData)" />
                                </b-col>-->
                            </b-row>
                        </div>
                    </template>
                </vuetable>
                <span class="EditModal">
                    <b-modal ref="edit-component-modal" title="Edit Role" hide-footer>
                        <b-container fluid>
                            <b-form @submit="EditRole">
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Role Name:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.name" placeholder="Required" type="name" required></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Role Description:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="form.description"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Parent Role ID:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="form.parentRoleId">
                                            <option value="">NONE</option>
                                            <option v-for="role in RoleList" v-if="role.Id != form.Id" :value="role.Id">
                                                {{ role.Name }}
                                            </option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12">
                                        <h3>Add or remove permissions from this role</h3>
                                        <b-list-group flush style="padding:0px;">
                                            <b-list-group-item style="padding:0px;">
                                                <div v-for="permission in PermissionList">
                                                    <div>
                                                        <b-form-checkbox size="lg" v-model="permission.checked" :value="true" :unchecked-value="false">
                                                            {{permission.Name}}
                                                        </b-form-checkbox>
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                                <b-row class="modal-btn-row">
                                    <div class="modal-btn-row-div">
                                        <b-button size="md" variant="secondary" @click="HideEditModal()">
                                            CANCEL
                                        </b-button>
                                        <b-button size="md" variant="primary" type="submit">
                                            CONFIRM
                                        </b-button>
                                    </div>
                                </b-row>
                            </b-form>
                        </b-container>
                    </b-modal>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlusSquare);
    import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
    library.add(faMinusSquare);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);

    export default {
        name : "RoleList",
        created() {
        },
        props: [],
        data: function () {
            return {
                search: "",
                RoleList: [],
                PermissionList: [],
                roleInfo: {},
                roleHasPermission:[],
                form: {
                    Id:'',
                    name: '',
                    description: '',
                    parentRoleId: '',
                },
                name: '',
                description: '',
                RoleTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Role Name',
                            sortField: 'Name'
                        },
                        {
                            name: 'Description',
                            title: 'Description',
                            sortField: 'Description'
                        },
                        {
                            name: '__slot:RoleActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            ClearForm() {
                this.form.Id = '';
                this.form.name = '';
                this.form.description = '';
                this.form.parentRoleId = '';
                for (var i = 0; i < this.PermissionList.length; i++) {
                    this.PermissionList[i].checked = false;
                }
                this.RefreshDataTable();
            },
            EditRoleButton(rowData) {
                this.form.Id = rowData.Id;
                this.form.name = rowData.Name;
                this.form.description = rowData.Description;
                this.form.parentRoleId = rowData.ParentRoleID;
                if (this.PermissionList.length != null) {
                    for (var i = 0; i < this.PermissionList.length; i++) {
                        if (this.PermissionList[i].Role != null) {
                            for (var j = 0; j < this.PermissionList[i].Role.length; j++) {
                                if (this.PermissionList[i].Role[j] == this.form.Id) {
                                    this.roleHasPermission[i] = this.PermissionList[i];
                                    this.roleHasPermission[i].checked = true;
                                    break; //one role to one permission, so if we have hit a role, then break
                                }
                                else {        
                                    this.roleHasPermission[i] = this.PermissionList[i];
                                    this.roleHasPermission[i].checked = false;
                                }

                            }
                        }
                        else {
                            this.roleHasPermission[i] = this.PermissionList[i];
                            this.roleHasPermission[i].checked = false;
                        }
                    }                   
                }
                this.$refs['edit-component-modal'].show();
            },
          
            ShowAddModal() {
                this.$refs['component-modal'].show();
            },
            HideEditModal() {
                this.$refs['edit-component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetRoles();
                this.GetPermissions();
            }, 
            AddRole(e) {
                e.preventDefault();
                let vm = this;
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddRole",
                     { 
                       Name: vm.form.name,
                       Description: vm.form.description,
                       ParentRoleID:vm.form.parentRoleId
                     },
                    this.AddRoleSuccess, () => { }, false);

            }, 
            AddRoleSuccess(response) {
                let vm = this;
                vm.$set(vm, 'roleInfo', response.data.data);
                for (var i = 0; i < this.PermissionList.length; i++) {
                    if (vm.PermissionList[i].checked == true) {
                        vm.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/AddPermissionRoleMembership",
                            { 
                            PermissionID: vm.PermissionList[i].Id,
                            RoleID: vm.roleInfo.Id,
                            },() => { }, () => { }, false);
                    }
                } 
                vm.RefreshDataTable();
                this.$refs['component-modal'].hide();
            },
            GetPermissions() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetPermissions", {}, this.GetPermissionsSuccess, () => { }, false);

            },
            GetPermissionsSuccess(response) {
                this.PermissionList = response.data.data;
            },
            GetRoles() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetRoles", {}, this.GetRolesSuccess, () => { }, false);

            },
            GetRolesSuccess(response) {
                this.RoleList = response.data.data;
                this.$refs.datatable.refresh();
            },
            EditRole(e) {
                e.preventDefault();
                //let vm = this;
                //build output array
                let permissionIDsChecked = [];
                this.PermissionList.forEach(function (permission) {
                    if (permission.checked) {
                        permissionIDsChecked.push(permission.Id);
                    }
                });
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/EditRole", {
                        Id: this.form.Id,
                        Name: this.form.name,
                        Description: this.form.description,
                        ParentRoleID: this.form.parentRoleId,
                        PermissionIDs: permissionIDsChecked
                    },this.EditRoleSuccess, () => { }, false);
                
            },
            EditRoleSuccess(response) {
                this.RefreshDataTable();
                this.HideEditModal();
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.RoleList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            }
        },
        components: {
            ActionButtonWithIcon,
            Vuetable
        },
        computed: {
            RoleListSelectable: function () {
                return this.RoleList.filter(r => r.Id != this.form.Id);
            }
        },
        mounted() {
            var vm = this;
            this.GetRoles();
            this.GetPermissions();
            let getRolesFunc = function () {
                vm.GetRoles();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getRolesFunc);
        }
    }
</script>

<style scoped>
</style>